export const setFieldValue = (field: string, value: string | undefined) => {
  if (value !== undefined && value !== null && value !== "") {
    window.localStorage.setItem(field, value);
  }
}

export const getFieldValue = (field: string): string | undefined => {
  return window.localStorage.getItem(field) ?? undefined
}